import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/style.css";
import { auth, db } from "./firebase";
import { Tooltip as ReactTooltip } from "react-tooltip";
import firebase from "firebase/compat/app";
import { Element, scroller } from "react-scroll";

const Chapter3_5 = () => {
  const navigate = useNavigate();
  const [selectedAnswers, setSelectedAnswers] = useState({ q1: "", q2: "" });
  const [error, setError] = useState("");
  const [userId, setUserId] = useState(null);

  const questions = [
    {
      question: "Frage 1: Wie funktioniert ein Man-in-the-Middle-Angriff?",
      options: [
        {
          value: "A",
          label:
            "Der Angreifer fängt die Kommunikation zwischen zwei Parteien ab und kann sie mitlesen oder manipulieren.",
        },
        {
          value: "B",
          label:
            "Der Angreifer kann die Kommunikation zwischen zwei Personen lesen, aber nicht verändern.",
        },
      ],
      correct: "A",
    },
    {
      question:
        "Frage 2: Wie kann man sich gegen einen Man-in-the-Middle-Angriff schützen, wenn man online einkauft?",
      options: [
        {
          value: "A",
          label: "Durch die Nutzung eines VPN um die Kommunikation mit der Website zu verschlüsseln.",
        },
        {
          value: "B",
          label:
            "Durch die Verwendung von HTTPS, wodurch die Verbindung verschlüsselt wird.",
        },
      ],
      correct: "A",
    },
  ];
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      scroller.scrollTo(location.hash.substring(1), {
        duration: 500,
        smooth: true,
        offset: -50,
      });
    }
  }, [location]);
  
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        setUserId(user.uid); 
      } else {
        console.error("Kein authentifizierter Benutzer gefunden");
        setError("Benutzer ist nicht authentifiziert");
        navigate("/cybersecurity/login"); 
      }
    });

   
    return () => unsubscribe();
  }, [navigate]);

  
  useEffect(() => {
    console.log("Aktuelle userId in 3_5.js:", userId);
  }, [userId]);

  const handleLogout = () => {
    
    auth
      .signOut()
      .then(() => {
        
        window.location.href = "/login"; 
      })
      .catch((error) => {
        console.error("Logout fehlgeschlagen:", error);
      });
  };

  const handleAnswerChange = (questionIndex, value) => {
    setSelectedAnswers((prev) => ({
      ...prev,
      [questionIndex]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const correctAnswers = questions.every(
      (q, index) => selectedAnswers[index] === q.correct
    );

    if (correctAnswers) {
      try {
        if (!userId) {
          console.error("userId ist nicht definiert");
          setError("Ein Fehler ist aufgetreten.");
          return;
        }

        
        const userDoc = await db.collection("cybersecurityProgress").doc(userId).get();

        console.log("userDoc:", userDoc.exists); 

        if (userDoc.exists) {
          
          await db
            .collection("cybersecurityProgress")
            .doc(userId)
            .update({
              lastChapter: "3_5",
              completedChapters:
                firebase.firestore.FieldValue.arrayUnion("3_5"),
            });
          console.log("Dokument aktualisiert mit Kapitel 3_5.");
        } else {
          
          await db
            .collection("cybersecurityProgress")
            .doc(userId)
            .set({
              lastChapter: "3_5",
              completedChapters: ["3_5"],
            });
          console.log("Dokument erstellt mit Kapitel 3_5.");
        }

        navigate("/cybersecurity/4_1"); 
      } catch (error) {
        console.error("Fehler beim Aktualisieren des Fortschritts:", error);
        setError("Ein Fehler ist aufgetreten. Versuche es später erneut.");
      }
    } else {
      setError("Die Antworten sind nicht korrekt. Versuche es erneut.");
    }
  };
  return (
    <div className="container">
      <div className="container py-5">
        <img
          src="/images/zebbs_Logo.svg"
          class="d-block mx-auto mb-4"
          alt=""
          style={{ width: "20%" }}
        />
        <div className="d-flex justify-content-between align-items-center mb-5 p-3 bg-body-tertiary rounded-3">
          {/* Breadcrumbs */}
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb breadcrumb-chevron mb-0">
              {/* Startseite (Home) */}
              <li className="breadcrumb-item">
                <Link className="link-body-emphasis" to="/cybersecurity/course-overview">
                  <i className="bi bi-house-door-fill"></i>
                  <span className="visually-hidden">Home</span>
                </Link>
              </li>

              {/* Library Link */}
              <li className="breadcrumb-item">
                <Link
                  className="link-body-emphasis fw-semibold text-decoration-none"
                  to="/cybersecurity/course-overview"
                >
                  3. Angriffe und Risiken
                </Link>
              </li>

              {/* Aktuelle Seite */}
              <li className="breadcrumb-item active" aria-current="page">
                Man-in-the-Middle
              </li>
            </ol>
          </nav>

          {/* Logout-Button */}
          <button className="btn btn-outline-dark" onClick={handleLogout}>
            Logout
          </button>
        </div>

        <div
          className="p-5 m-0 rounded-3"
          style={{
            position: "relative",
            backgroundColor: "#009fe0",
            margin: "25px",
            textAlign: "center",
          }}
        >
          <h3 className="text-center p-3">Kapitel 3: Angriffe und Risiken</h3>
          <h2 className="text-center p-5">Man-in-the-Middle</h2>
          <img
            src="/images/mitm.webp"
            alt="MITM"
            style={{ position: "relative", maxWidth: "45%", height: "auto" }}
          />
        </div>

        <div className="p-5 text-center">
          <h2 className="p-4">Man-in-the-Middle-Angriff</h2>
          <p className="col-lg-11 mx-auto">
            Bei einem Man-in-the-Middle (MITM)-Angriff schaltet sich ein
            Angreifer unbemerkt zwischen zwei kommunizierende Parteien (z. B.
            Nutzer und Server). Ziel ist es, den Datenverkehr abzufangen, zu
            belauschen oder sogar zu manipulieren. Dies ist besonders
            gefährlich, wenn sensible Informationen wie Login-Daten,
            Bankverbindungen oder vertrauliche Geschäftsinformationen übertragen
            werden.
            <br />
            <br />
            Wenn sich ein Nutzer in einem Café mit dem öffentlichen WLAN
            verbindet, um z. B. auf sein Online-Banking zuzugreifen, kann ein
            Angreifer, der sich im gleichen Netzwerk befindet, den Datenverkehr
            mithilfe spezieller Software abfangen. Obwohl der Nutzer sich auf
            der legitimen Website seiner Bank befindet, könnte der Angreifer den
            Datenstrom abfangen und Anmeldeinformationen speichern. Anschließend
            kann er die Bankverbindung manipulieren, sodass er möglicherweise
            eine Überweisung auf sein eigenes Konto veranlasst, während der
            Nutzer glaubt, Geld an einen legitimen Empfänger zu überweisen. So
            wäre der Nutzer Opfer eines Man-in-the-Middle-Angriffs geworden.
          </p>

      <p className="col-lg-11 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-beispiel rounded-2">
              <img
                src="/images/attack.svg"
                alt="Angriff"
                style={{
                  position: "relative",
                  maxWidth: "10%",
                  height: "auto",
                }}
              />
              Ende 2025 wurde ein Mann in Australien verurteilt, weil er an Flughäfen und sogar in Flugzeugen gefälschte WLAN-Netze mit echten Namen nachgebaut hat. Wer sich damit verband, wurde auf eine Login-Seite umgeleitet und gab dort Zugangsdaten ein – der Angreifer saß sprichwörtlich „in der Mitte“ zwischen Opfer und Internet und konnte Daten abgreifen. (afp.gov.au, 2025)
            </p>









          <p className="col-lg-11 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-danger rounded-2">
            <img
              src="/images/fact.svg"
              alt="Transparent"
              style={{
                position: "relative",
                maxWidth: "8%",
                height: "auto",
              }}
            />
            Über 50% aller MITM-Angriffe zielen auf das Abfangen sensibler
            Informationen wie Login-Daten und Bankinformationen ab. Banken und
            Finanzdienstleister sind Hauptziele für MITM-Angriffe. Besonders
            betroffen ist der Online-Banking-Bereich.
          </p>
        </div>
      </div>

      <div className="grey-section">
        <div className="container pb-5">
          <div className="p-5 text-center">
            <h3 className="p-5">Man-in-the-Middle-Angriffe im Finanzwesen:</h3>
            <p className="col-lg-11 mx-auto">
              Die Finanzbranche ist ein beliebtes Ziel für solche Angriffe, weil
              große Geldsummen bewegt werden und viele Angriffsvektoren
              existieren. Banken und Finanzinstitute bieten eine Vielzahl
              digitaler Dienstleistungen an, von Apps und
              Online-Banking-Portalen bis hin zu{" "}
              <span
                data-tooltip-id="tooltip-api"
                data-tooltip-content="Eine API-Schnittstelle ist eine Art Brücke, die es verschiedenen Programmen ermöglicht, miteinander zu sprechen. Sie legt fest, wie Programme Daten austauschen und Befehle verstehen können. Mit einer API können Programme Funktionen nutzen, ohne den ganzen Code selbst schreiben zu müssen."
                className="custom-tooltip-trigger"
              >
                {" "}
                API-Schnittstellen.{" "}
              </span>{" "}
              Jede dieser Technologien kann potenzielle Schwachstellen
              aufweisen. Hinzu kommt die Abhängigkeit von Drittanbietern wie
              Zahlungsdienstleistern, deren Sicherheit nicht vollständig
              kontrolliert werden kann. Schließlich spielt auch menschliches
              Verhalten eine Rolle: Viele Menschen nutzen ungeschützte
              öffentliche WLAN-Netzwerke, klicken auf verdächtige Links oder
              erkennen{" "}
              <Link to="/cybersecurity/2_4" className="icon-link">
                {" "}
                <svg className="bi" aria-hidden="true">
                  {" "}
                  <use xlinkHref="#book"></use>{" "}
                </svg>{" "}
                Phishingmails{" "}
              </Link>
              nicht.
              <br />
              <br />
              Im Finanzsektor gibt es zwei Hauptziele für MITM-Angriffe:
            </p>
            <p className="col-lg-10 text-start mx-auto">
              <strong>
                {" "}
                1. Die Kompromittierung von Online-Banking-Sitzungen:{" "}
              </strong>{" "}
              Angreifer können sich beispielsweise mit verschiedenen Techniken
              in ungeschützte Netzwerke einklinken und so den Datenverkehr
              zwischen dir und deiner Bank abfangen, ohne das du es bemerkst.
              <br />
              <br />
              <strong>
                {" "}
                2. Die Manipulation von Zahlungsdaten in Unternehmen:{" "}
              </strong>{" "}
              Hier wird die E-Mail-Kommunikation zwischen einem Unternehmen und
              seinen Geschäftspartnern oder internen Mitarbeitern gezielt
              nachgeahmt. Ein MITM-Angreifer kann dabei die Nachrichten lesen
              oder sogar verändern, bevor sie den Empfänger erreichen. Zum
              Beispiel könnte der Angreifer eine legitime Zahlungseinweisung
              umleiten oder gefälschte Zahlungsdetails senden, um Geld an sich
              selbst zu transferieren. Diese Art des Betrugs wird auch als{" "}
              <strong> Business Email Compromise (BEC) </strong> bezeichnet und
              ist eine besonders perfide Form des MITM.
              <br />
              <br />
            </p>
            <ReactTooltip
              id="tooltip-api"
              place="top"
              className="custom-tooltip"
            />
            <p className="col-lg-11 mx-auto d-inline-flex p-5 mb-5 text-decoration-none border-beispiel rounded-2">
              <img
                src="/images/attack.svg"
                alt="Angriff"
                style={{
                  position: "relative",
                  maxWidth: "10%",
                  height: "auto",
                }}
              />
              Ein bekanntes Beispiel für die Auswirkungen solcher Angriffe ist
              der Hack des SWIFT-Zahlungsnetzwerks, bei dem 2016 durch eine
              Manipulation des Datenverkehrs 81 Millionen Dollar von der
              Zentralbank Bangladeschs entwendet wurden. Auch
              Mobile-Banking-Apps sind ein häufiges Ziel. Angreifer nutzen
              gefälschte WLAN-Hotspots, um Zugangsdaten und Transaktionscodes
              abzugreifen. Selbst im Bereich der Cryptowährungen haben
              MITM-Angriffe Wallet-Adressen manipuliert, sodass Gelder unbemerkt
              an die Angreifer transferiert wurden.
            </p>
            <p className="col-lg-11 mx-auto">
              Um solche Angriffe zu verhindern, setzen Banken und Unternehmen
              auf eine Kombination aus Technologien, Prozessen und
              Kundenaufklärung.
              <br />
              <br /> Moderne Verschlüsselungen wie <strong>
                {" "}
                TLS 1.3{" "}
              </strong>{" "}
              ermöglichen sicherere Verbindungen. TLS wurde als Nachfolger von
              SSL entwickelt. Damit wurden Schwachstellen behoben zudem wurden
              eine robustere Verschlüsselung sowie sicherere Verbindungen
              gewährleistet. <br />
              <br /> Eine
              <Link to="/cybersecurity/2_3#mfa" className="icon-link">
                <svg className="bi" aria-hidden="true">
                  <use xlinkHref="#book"></use>
                </svg>{" "}
                Multi-Faktor-Authentifizierung (MFA)
              </Link>{" "}
              sollte inzwischen Standard sein, sodass selbst gestohlene
              Zugangsdaten ohne den zweiten Faktor nutzlos sind.
              <br /> <br />
              <strong> Out-of-Band-Authentifizierungsmethoden, </strong> bei
              denen bei größeren Überweisungen Zahlungsdetails über einen
              zweiten Kanal wie SMS oder Telefonanruf bestätigt werden müssen,
              erhöhen die Sicherheit. Darüber hinaus setzen viele
              Finanzinstitute auf KI-gestützte Systeme, die Transaktionsmuster
              analysieren und verdächtige Aktivitäten automatisch erkennen und
              blockieren können.
            </p>
          </div>
        </div>
      </div>

      <div className="gelb-section">
        <div className="container p-5">
          <div className="p-5 text-center">
            <h3 className="p-5">Arten von Man-in-the-Middle-Angriffen</h3>
            <p className="col-lg-11 mx-auto">
              Man-in-the-Middle-Angriffe können in verschiedenen Formen
              auftreten, jede mit ihren eigenen Techniken und Zielen:
              <br />
              <br />
              <strong>WLAN-Hijacking: </strong> Angreifer nutzen ungesicherte
              öffentliche WLAN-Netzwerke als Angriffsfläche. Sie erstellen ein
              täuschend echt wirkendes, bösartiges WLAN (z. B. „Free Public
              WiFi“) oder manipulieren ein bestehendes Netzwerk. Sobald ein
              Nutzer eine Verbindung herstellt, kann der Angreifer den gesamten
              Datenverkehr überwachen, manipulieren und vertrauliche
              Informationen abgreifen.
              <br />
              <br />
              <strong>Session Hijacking: </strong>Wenn ein Nutzer sich auf einem
              Portal eingeloggt und nach seiner Tätigkeit nicht wieder ausloggt,
              kann sich der Angreifer in diese "Session" einfach wieder
              einloggen. Durch den Diebstahl von Session-Cookies kann er sich
              als legitimer Benutzer ausgeben, ohne weitere Anmeldeinformationen
              zu benötigen. Dies ermöglicht den Zugriff auf geschützte Konten,
              wie E-Mail oder Online-Banking.
              <br />
              <br />
              <strong> DNS-Spoofing: </strong>Angreifer manipulieren
              DNS-Anfragen, um Benutzer auf gefälschte Webseiten umzuleiten,
              obwohl die korrekte URL eingegeben wurde. Das DNS (Domain Name
              System) ist ein System, das dafür sorgt, dass Webseiten über ihre
              Domainnamen (wie z. B. www.zeb-business-school.com) anstelle von
              IP-Adressen gefunden werden können. Es übersetzt die numerische,
              für Computer verständliche, IP-Adressen (z. B. 192.0.2.1) in für
              alle Nutzer lesbare Webadressen. Manipulierte DNS-Anfragen nutzen
              hierbei Schwachstellen aus, um den Benutzer auf eine falsche
              Webseite umzuleiten. Diese Technik wird häufig verwendet, um
              Anmeldedaten oder Zahlungsinformationen zu stehlen, etwa durch
              täuschend echt aussehende Fake-Bankseiten.
              <br />
              <br />
              <strong>HTTPS-Spoofing: </strong>Obwohl HTTPS für eine
              verschlüsselte Verbindung steht, können Angreifer gefälschte
              SSL-Zertifikate verwenden, um eine scheinbar sichere Verbindung
              vorzutäuschen. Der Benutzer glaubt, die Kommunikation sei
              geschützt, während der Angreifer die übertragenen Daten
              entschlüsseln und abfangen kann.
              <br />
              <br />
              <strong>SSL-Stripping: </strong>Hier wird die Verschlüsselung von
              HTTPS-Verbindungen entfernt. Dadurch werden sensible Daten im
              Klartext übertragen und können leicht abgefangen werden.
              <br />
              <br />
              <strong>IP-Spoofing: </strong> Angreifer manipulieren IP-Adressen,
              um sich als vertrauenswürdiger Kommunikationspartner auszugeben.
              Indem sie Datenpakete über ihre eigenen Server umleiten, können
              sie die Kommunikation überwachen oder verändern, bevor die Pakete
              ihr Ziel erreichen.
              <br />
              <br />
              <strong>ARP-Spoofing (Address Resolution Protocol): </strong>
              Durch die Manipulation des ARP-Protokolls täuscht der Angreifer
              Geräten im Netzwerk vor, dass seine{" "}
              <span
                data-tooltip-id="tooltip-mac"
                data-tooltip-content="Die MAC-Adresse (Media Access Control) ist eine eindeutige Identifikationsnummer für Geräte in einem Netzwerk, wie z.B. für deinen Computer oder dein Smartphone. Sie wird vom Hersteller des Geräts festgelegt und hilft dabei, das Gerät im Netzwerk zu erkennen. Die MAC-Adresse ist für jedes Gerät unterschiedlich und wird oft verwendet, um Netzwerke sicherer zu machen oder den Zugang zu verwalten."
                className="custom-tooltip-trigger"
              >
                {" "}
                MAC-Adresse{" "}
              </span>{" "}
              die des Routers ist. Dies führt dazu, dass der gesamte
              Datenverkehr über sein Gerät läuft, bevor er an den eigentlichen
              Empfänger weitergeleitet wird.
              <br />
              <br />
              <strong>Phishing und Social Engineering: </strong>
              Manchmal werden Nutzer gezielt auf gefälschte Websites gelockt,
              die legitimen Seiten täuschend ähnlich sehen. Hier agiert der
              Angreifer als "Man in the Browser". Er erhält Informationen wie
              Passwörter direkt vom Nutzer.
              <br />
              <br />
              Diese Techniken werden häufig kombiniert, um effektiver zu sein,
              und können bei unzureichenden Sicherheitsmaßnahmen zu erheblichen
              Schäden führen. <br />
              <br />
            </p>
            <ReactTooltip
              id="tooltip-mac"
              place="top"
              className="custom-tooltip"
            />

            <p className="col-lg-11 mx-auto d-inline-flex p-5 mb-5 text-decoration-none border-beispiel rounded-2">
              <img
                src="/images/attack.svg"
                alt="Angriff"
                style={{
                  position: "relative",
                  maxWidth: "10%",
                  height: "auto",
                }}
              />
              2015 hatte der Computer-Hersteller Lenovo auf vielen seiner
              Laptops eine vorinstallierte Software namens Superfish integriert,
              die eigentlich dazu dienen sollte, Werbung auf Webseiten der
              Nutzer anzuzeigen. Allerdings wies die Software eine gravierende
              Sicherheitslücke auf: Sie verwendete ein unsicheres
              Root-Zertifikat, das es Angreifern ermöglichte,
              Man-in-the-Middle-Angriffe durchzuführen. Durch dieses unsichere
              Zertifikat konnten Angreifer leicht die verschlüsselte
              Kommunikation der Benutzer über HTTPS-Webseiten abfangen und
              manipulieren. Vertrauliche Informationen wie Passwörter,
              Kreditkartendaten oder andere persönliche Daten von den Nutzern
              wurden kompromittiert, ohne dass es bemerkt wurde. Der
              Superfish-Vorfall führte zu großer Empörung und einem erheblichen
              Reputationsverlust für Lenovo. Lenovo sah sich gezwungen, die
              Software zu entfernen und Tools bereitzustellen, mit denen
              Benutzer das unsichere Zertifikat von ihren Laptops löschen
              konnten.
            </p>
          </div>
        </div>
      </div>

      <div className="grey-section">
        <div className="container p-5">
          <div className="p-5 text-center">
            <h3 className="p-5">
              Anzeichen für einen Man-in-the-Middle-Angriff
            </h3>
            <p className="col-lg-11 mx-auto">
              Natürlich versucht ein MIMT-Angriff unbedingt unbemerkt zu
              bleiben. Dennoch gibt es einige Anzeichen und Maßnahmen, die
              helfen können MIMT-Angriffe zu identifizieren:
              <br />
              <br />
              Wenn der Browser eine <strong> Zertifikatswarnung </strong>{" "}
              ausgibt, könnte dies auf ein kompromittiertes SSL-Zertifikat
              hinweisen. Dann besteht die Gefahr, dass ein Angreifer versucht,
              die Verbindung abzufangen.
              <br />
              <br />
              Ein plötzlicher{" "}
              <strong>
                {" "}
                Abfall der Netzwerkgeschwindigkeit oder häufige
                Verbindungsabbrüche{" "}
              </strong>{" "}
              können darauf hindeuten, dass Datenverkehr umgeleitet wird. Denn
              ein MITM-Angriff benötigt zusätzliche Zeit, um Daten zu
              verarbeiten oder zu manipulieren.
              <br />
              <br />
              Wenn ein Nutzer in einem öffentlichen WLAN unterwegs ist und
              unerwartet mit einem unbekannten WLAN-Hotspot verbunden wird, der
              einen generischen oder nicht vertrauenswürdigen Namen hat (z. B.
              'Free Wi-Fi' oder 'WLAN'), könnte dies ein{" "}
              <strong> gefälschter Hotspot </strong> sein.
              <br />
              <br />
              <strong>Ungewöhnliche Kontoaktivitäten </strong> oder Änderungen
              auf einem Konto, wie unerklärliche Überweisungen oder fehlende
              Nachrichten, können darauf hinweisen, dass ein Angreifer Daten
              manipuliert hat.
            </p>
          </div>
        </div>
      </div>

      <div className="white-section">
        <div className="container p-5">
          <div className="p-5 text-center">
            <h3 className="p-5">
              Abwehrstrategien gegen Man-in-the-Middle-Angriffe
            </h3>

            <p className="col-lg-11 mx-auto">
              Die Prävention von MITM-Angriffen erfordert eine Kombination aus
              technischen Maßnahmen und verantwortungsvollem Verhalten: <br />
              <br />
            </p>
            <p className="col-lg-10 text-start mx-auto">
              <strong> Verschlüsselung und sichere Verbindungen: </strong>
              Es sollten generell nur HTTPS-Websites besucht werden, um
              sicherzustellen, dass die Kommunikation verschlüsselt ist. Ein
              Schloss-Symbol in der Adressleiste des Browsers bestätigt eine
              sichere Verbindung. Unternehmen sollten zudem sicherstellen, dass
              ihre Server aktuelle SSL/TLS-Zertifikate verwenden.
              <br />
              <br />
              <strong> Meiden unsicherer WLAN-Netzwerke: </strong>
              Öffentliche WLAN-Netzwerke bieten Angreifern ideale
              Voraussetzungen für MITM-Angriffe. Wenn solche Netzwerke genutzt
              werden müssen, sollte sichergestellt werden, dass alle
              Verbindungen verschlüsselt sind.
              <br />
              <br />
              <strong> Multi-Faktor-Authentifizierung (MFA): </strong>
              Selbst wenn ein Angreifer Zugriff auf Zugangsdaten erhält,
              erschwert eine MFA den unbefugten Zugriff erheblich.
              <br />
              <br />
              <strong> Nutzung von VPNs: </strong>
              Ein virtuelles privates Netzwerk (VPN) verschlüsselt den
              Datenverkehr und macht es Angreifern deutlich schwerer, Daten
              abzufangen.
            </p>
          </div>
        </div>
      </div>

      <div className="white-section">
        <div className="container">
          <div
            className="safe rounded-2 text-center"
            style={{ backgroundColor: "#fec748" }}
          >
            <img
              src="/images/abwehr.svg"
              alt="Abwehr"
              style={{
                position: "relative",
                maxWidth: "7%",
                height: "auto",
              }}
            />
            <h3 className="p-5">Was ist ein VPN?</h3>
            <Element name="vpn">
              <p className="col-lg-11 mx-auto">
                Ein virtuelles privates Netzwerk (VPN) erstellt eine
                <strong> verschlüsselte Verbindung </strong> zwischen deinem
                Gerät und einem Server, sodass der Datenverkehr nicht abzufangen
                oder zu lesen ist. Ein VPN schützt besonders in unsicheren
                öffentlichen WLAN-Netzwerken, wo Cyberkriminelle leicht
                ungesicherte Daten abfangen könnten. Ob in einem Café, am
                Flughafen oder im Hotel – mit einem VPN bleibt der Datenverkehr
                geschützt.
                <br />
                <br /> Mitarbeiter von Unternehmen können außerhalb des Büros
                (z. B. im Homeoffice oder auf Reisen) sicher auf das
                Unternehmensnetzwerk zugreifen. Dies ist besonders wichtig, wenn
                vertrauliche Daten verarbeitet werden oder auf
                Unternehmensressourcen zugegriffen wird. VPN verschlüsseln die
                gesamte Kommunikation zwischen dem Gerät eines Mitarbeitenden
                und dem Unternehmensnetzwerk.
                <br />
                <br />
                Die Verschlüsselung sorgt dafür, dass niemand – weder Hacker
                noch der Internetanbieter oder Regierungsbehörden – auf die
                übermittelten Informationen zugreifen kann. Selbst wenn jemand
                den Datenverkehr abfangen würde, wären die Inhalte nicht lesbar.
                Diese Sicherheit wird durch komplexe Verschlüsselungsalgorithmen
                erreicht, die den Datenverkehr in einen sicheren Tunnel leiten.{" "}
                <br />
                <br />
                Neben der Sicherheit bietet ein VPN auch{" "}
                <strong> Anonymität. </strong> Indem der gesamte Datenverkehr
                über den VPN-Server geleitet wird, bleibt die echte IP-Adresse
                verborgen. Websites und Online-Dienste sehen nur die IP-Adresse
                des VPN-Servers, nicht die des Nutzers. Das macht es nicht nur
                schwieriger, Aktivitäten zurückzuverfolgen, sondern schützt auch
                vor gezieltem Tracking oder personalisierter Werbung.
                <br />
                <br />
                Ein zusätzlicher Vorteil von VPN ist der Zugriff auf geografisch
                gesperrte Inhalte. Indem der Nutzer sich mit einem VPN-Server in
                einem anderen Land verbindet, kann er digitale Barrieren
                umgehen. Ob es sich um Streaming-Inhalte wie Netflix USA oder um
                Informationen handelt, die in seinem Land blockiert sind: VPN
                ermöglichen den Zugang, indem sie den Standort virtuell
                verändern. Unternehmen können durch VPN so sicherstellen, das
                ihre Kommunikation in Ländern mit strengen Überwachungsmaßnahmen
                und weniger Datenschutz nicht überwacht wird.
              </p>

              <h3 className="pt-5">Wie funktioniert ein VPN?</h3>
              <p className="p-3 col-lg-9 text-start mx-auto">
                <section class="pt-5 text-start">
                  <ul class="timeline">
                    <li class="timeline-item mb-5">
                      <h5 class="fw-bold">1. Verbindung zum VPN-Server:</h5>

                      <p>
                        Der gesamte Datenverkehr wird an den VPN-Server
                        gesendet, bevor er ins Internet gelangt. Der Server
                        fungiert als Vermittler, verbirgt die echte IP-Adresse
                        und schützt die Identität.
                      </p>
                    </li>

                    <li class="timeline-item mb-5">
                      <h5 class="fw-bold">2. Verschlüsselung der Daten:</h5>

                      <p>
                        Alle Daten, die von einem Gerät zum VPN-Server fließen,
                        werden verschlüsselt. Das stellt sicher, dass niemand
                        die Inhalte lesen kann, selbst wenn sie abgefangen
                        werden.
                      </p>
                    </li>
                    <li class="timeline-item mb-5">
                      <h5 class="fw-bold">3. IP-Adresse wird verborgen:</h5>

                      <p>
                        Das Gerät des Nutzers verwendet nicht mehr seine eigene
                        IP-Adresse, sondern die des VPN-Servers. Wenn der Nutzer
                        nun eine Webseite besucht oder Online-Dienste nutzt,
                        sieht es so aus, als ob er vom Standort des VPN-Servers
                        aus zugreift, und nicht von seinem tatsächlichen
                        Standort. Dies schützt seine Privatsphäre und hilft,
                        seinen Standort zu verschleiern.
                      </p>
                    </li>

                    <li class="timeline-item mb-5">
                      <h5 class="fw-bold">
                        4. Daten an den Zielserver weitergeleitet:
                      </h5>

                      <p>
                        Der verschlüsselte Datenverkehr fließt durch einen
                        sicheren Tunnel, der vor Abhörversuchen oder
                        Manipulationen schützt. Besonders in öffentlichen
                        WLAN-Netzwerken bietet dies ein unverzichtbares Maß an
                        Sicherheit.
                      </p>
                    </li>
                    <li class="timeline-item mb-5">
                      <h5 class="fw-bold">5. Antwort zurück an den Nutzer:</h5>

                      <p>
                        Wenn der Zielserver auf eine Anfrage antwortet, wird die
                        Antwort zuerst zum VPN-Server geschickt, wo sie
                        entschlüsselt wird. Dann wird sie über den sicheren
                        Tunnel wieder an das ursprüngliche Gerät weitergeleitet,
                        wo sie erneut entschlüsselt wird.
                      </p>
                    </li>
                  </ul>
                </section>
              </p>

              <p className="col-lg-11 text-center mx-auto">
                Die meisten VPN werden als Software (VPN-Client) bereitgestellt,
                die auf dem Computer, Smartphone oder Tablet direkt installiert
                werden kann. Zwar bieten Betriebssysteme wie Windows und macOS
                oft von Haus aus Unterstützung für VPNs. Für umfassenden Schutz,
                insbesondere bei der Nutzung mehrerer Anwendungen, ist jedoch
                eine vollständige VPN-Software die bessere Wahl.
                <br />
                <br />
                <strong>
                  {" "}
                  Worauf sollte man bei der Auswahl eines VPN-Anbieters achten?{" "}
                </strong>
                <br />
                <br />
                Ein guter VPN-Anbieter zeichnet sich durch eine strenge
                "No-Logs"-Richtlinie aus. Das bedeutet, dass der VPN-Anbieter
                keine Aufzeichnungen oder Logs über die Aktivitäten seiner
                Nutzer speichert. Er protokolliert nicht welche Websites besucht
                werden, welche Daten gesendet oder empfangen werden, wann jemand
                online ist oder mit wem er kommuniziert. Diese Richtlinie stellt
                sicher, dass die Privatsphäre der Nutzer gewahrt bleibt, da im
                Falle einer Anfrage von Dritten oder Behörden keine Nutzerdaten
                zur Verfügung stehen. Außerdem sollte der VPN-Anbieter schnelle
                Server an vielen Standorten halten und moderne Protokolle wie
                OpenVPN oder WireGuard unterstützen. Daneben sollte darauf
                geachtet werden, dass der Anbieter Apps für alle Geräte
                bereitstellt und einen zuverlässigen Kundensupport bietet.
                Kostenlose VPNs sind oft unsicher und speichern möglicherweise
                Daten. Seriöse und kostenpflichtige Anbieter sind eher zu
                empfehlen.
                <br />
                <br />
                <strong> Grenzen eines VPN: </strong>
                <br />
                <br />
                Ein VPN schützt den Datenverkehr nicht vor allen Gefahren.{" "}
                <Link to="/cybersecurity/2_4" className="icon-link">
                  {" "}
                  <svg className="bi" aria-hidden="true">
                    {" "}
                    <use xlinkHref="#book"></use>{" "}
                  </svg>{" "}
                  Phishing,{" "}
                </Link>{" "}
                unsichere Downloads oder{" "}
                <Link to="/cybersecurity/3_1" className="icon-link">
                  {" "}
                  <svg className="bi" aria-hidden="true">
                    {" "}
                    <use xlinkHref="#book"></use>{" "}
                  </svg>{" "}
                  Malware{" "}
                </Link>{" "}
                können trotzdem auftreten. Ein VPN sollte deshalb mit anderen
                Sicherheitsmaßnahmen wie Antivirenprogrammen und{" "}
                <Link to="/cybersecurity/2_3" className="icon-link">
                  {" "}
                  <svg className="bi" aria-hidden="true">
                    {" "}
                    <use xlinkHref="#book"></use>{" "}
                  </svg>{" "}
                  sicheren Passwörtern{" "}
                </Link>{" "}
                kombiniert werden.
              </p>
            </Element>
          </div>
        </div>
      </div>
      {/* Fragenteil */}
      <div className="container pt-5 my-5">
        <div className="text-center m-4">
          <h2>Überprüfe dein Wissen</h2>
          <p className="col-lg-11 mx-auto">
            Mit den richtigen Antworten kommst du weiter!
          </p>
        </div>
        <div className="row justify-content-center">
          <div className="col-md-10 text-start">
            <form onSubmit={handleSubmit}>
              {questions.map((question, index) => (
                <div key={index} className="mb-4">
                  <p className="fs-4">{question.question}</p>{" "}
                  {question.options.map((option) => (
                    <div key={option.value} className="form-check">
                      <input
                        className="form-check-input me-2"
                        type="radio"
                        name={`question${index}`}
                        value={option.value}
                        checked={selectedAnswers[index] === option.value}
                        onChange={() => handleAnswerChange(index, option.value)}
                      />
                      <label className="form-check-label fs-5">
                        {option.label}
                      </label>{" "}
                    </div>
                  ))}
                </div>
              ))}
              {error && <p className="text-danger">{error}</p>}
              <div className="text-center">
                <button type="submit" className="btn btn-primary">
                  überprüfen
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* Ende Fragenteil */}
    </div>
  );
};

export default Chapter3_5;
